import './loading_curtain.sass'
import {Image, Spin} from 'antd'
import logo from '../../gfx/logo-trails-of-ice-and-fire-color.svg'

export default function LoadingCurtain({active = false, loading = false}) {
  return (
    <div className={`curtain ${active ? 'active' : ''}`}>

      <Image className="logo" src={logo} preview={false}/>

      {/*<div className="text-wrapper">
        <div className="text">

          <div className="loading-text">Loading</div>
          <div className="welcome-text">Welcome</div>
        </div>
      </div>
      <div className="loading-bar"></div>*/}
      <div style={{height: '2em'}}>
        <Spin size="large" className="mt-3"/>
      </div>
    </div>
  )
}